import React from 'react';
import LinkColumn from 'src/common/utils/TableColumnIcons/LinkColumn';

export const ActionColumnLink = (value, row, rowIndex, { onAdd }) => {
	return (
		<>
			<LinkColumn value={value} onClick={() => onAdd(row)} color="primary" />
		</>
	);
};
